// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"bdce30a0d51fa48e","8717":"f59667e7e9692e80","9190":"f59667e7e9692e80"}[chunkId] + ".css";
};